import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { api } from "./api";

let wired = false;
let nativeToken: string | null = null;

function wireListeners() {
  if (wired) return;
  wired = true;
  const platform = Capacitor.getPlatform();
  void PushNotifications.addListener("registration", (t) => {
    if (t.value && t.value !== nativeToken) {
      nativeToken = t.value;
      void api.registerPushToken(t.value, platform);
    }
  });
  void PushNotifications.addListener("registrationError", () => {});
  void PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
    const data = action.notification.data as Record<string, string> | undefined;
    const link = data?.link || "/";
    window.location.assign(link);
  });
}

export async function enableNativePush(): Promise<"granted" | "denied"> {
  let perm = await PushNotifications.checkPermissions();
  if (perm.receive === "prompt" || perm.receive === "prompt-with-rationale") {
    perm = await PushNotifications.requestPermissions();
  }
  if (perm.receive !== "granted") return "denied";
  wireListeners();
  await PushNotifications.register();
  return "granted";
}
